import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import { loadSuccess, loadFailure, loadRequest } from './actions';

export function* loadConsultaAgendamentos({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getConsultaAgendamento&token=${state.auth.token}`,
      {
        filtro: payload.filtro,
        parceiros: payload.parceiros,
        codCdd: payload.codCdd,
      }
    );
    yield put(
      loadSuccess(response.data.agendamentos, {
        total: response.data.total,
        totAgendado: response.data.totAgendado,
        totExpedido: response.data.totExpedido,
        totEntrega: response.data.totEntrega,
        totColeta: response.data.totColeta,
        tAgeEntrega: response.data.tAgeEntrega,
        tAgeColeta: response.data.tAgeColeta,
        tExpColeta: response.data.tExpColeta,
        tExpEntrega: response.data.tExpEntrega,
        totFerro: response.data.totFerro,
        totMadeira: response.data.totMadeira,
        qtdPlat: response.data.qtdPlat,
      })
    );
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar a lista de cidades, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
